import HttpService from '@/common/services/HttpService'
import type { CustomerDetailsDTOV1, CustomerDTOV3, CustomerFieldConfig } from '@/common/types/customer'
import type {
  SearchDuplicatesDTOV1,
  SearchDuplicatesParamsDTOV1,
  CustomerWithCustomfieldDTOV1,
  MergedCustomerWithCustomfield,
} from '@/agent/types/customerFederation'

/**
 * @deprecated
 */
export const getCustomer = async (customerId: number): Promise<CustomerWithCustomfieldDTOV1> => {
  return HttpService.getData<CustomerWithCustomfieldDTOV1>(`/api/v1/customers/${customerId}`)
}

export const getIfCustomerHasDuplicates = (customerRef: string | null, customerPhones: Array<string>, customerEmails: Array<string>) => {
  if (!customerRef && !customerPhones.length && !customerEmails.length) return []

  const customerParams: SearchDuplicatesParamsDTOV1 = {
    customerReference: customerRef || undefined,
    phones: customerPhones.join(',') || undefined,
    emails: customerEmails.join(',') || undefined,
  }

  return HttpService.putData<SearchDuplicatesDTOV1>(
    `/api/v1/customers/search-duplicates`,
    {},
    {
      params: customerParams,
    },
  )
}

export const findDuplicateCustomersById = (customerId: number) => {
  return HttpService.putData<SearchDuplicatesDTOV1>(`/api/v1/customers/${customerId}/search-duplicates`)
}

export const mergeCustomer = (archivedCustomerId: number | null, targetCustomer: MergedCustomerWithCustomfield) => {
  return HttpService.putData<{ id: number }>(`/api/v1/customers/${archivedCustomerId}/merge`, targetCustomer)
}

export const mergeCustomerOnCreate = (
  existingCustomerId: number | null,
  newCustomer: CustomerWithCustomfieldDTOV1,
  targetCustomer: MergedCustomerWithCustomfield,
) => {
  return HttpService.putData<{ id: number }>(`/api/v1/customers/${existingCustomerId}/update-by-merge-on-create`, {
    customerMerge: targetCustomer,
    customer: newCustomer,
  })
}

export const getBulkCustomers = async (ids?: number[], { includes, expands }: CustomerFieldConfig = {}): Promise<CustomerDetailsDTOV1[]> => {
  const params = {
    include: includes?.size ? [...includes].join() : undefined,
    expand: expands?.size ? [...expands].join() : undefined,
  }
  return HttpService.postData<CustomerDetailsDTOV1[]>(`/api/v1/bulk-customers/fetch`, { ids }, { params })
}

export const getCustomerV3 = async (customerId: number, { includes, expands }: CustomerFieldConfig = {}): Promise<CustomerDTOV3> => {
  const params = {
    include: includes?.size ? [...includes].join() : undefined,
    expand: expands?.size ? [...expands].join() : undefined,
  }
  return HttpService.getData<CustomerDTOV3>(`/api/v3/customers/${customerId}`, {
    params,
  })
}
